module.exports = __webpack_public_path__ + "static/media/fanfare.3d9de2c5.mp3";